// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__NjMd5","row":"footer_row__VG-Ch","logo":"footer_logo__ke--D","navigation":"footer_navigation__uOq6I","social":"footer_social__7XGwd"};